import React, { ReactNode } from 'react';
import { DialogContent } from '@mui/material';

const CommonDialogContent = ({ children }: { children?: ReactNode }) => (
  <DialogContent
    sx={{
      p: 0,
      bgcolor: 'background.default',
      display: 'flex',
      flexDirection: 'column'
    }}
  >
    {children}
  </DialogContent>
);

export default CommonDialogContent;
